<!-- 公共头部 -->
<template>
  <div class="header_wrap" :style="color">
    <!-- <div class="home_header" v-if="currentPath == '/'">
      <div class="home_left">ChatLearning</div>
      <div class="home_right">
        <el-button type="text" style="color: #5e6d82">登录</el-button>
      </div>
    </div> -->
    <div class="other_header">
      <div class="other_left">
        <!-- <svg-icon icon-class="return" className="download_user" /> -->
        <svg-icon icon-file-name="return" @click="goBack" />
      </div>
      <div class="other_right">欢迎你，{{nickname | desensitization}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPath: "",
      color: "",
      color_s: [
        "#FDF993",
        "#607DBF",
        "#E6B6C9",
        "#AADAED",
        "#6B87A1",
        "#C2D0A4",
        "#FF0000",
        "#946029",
        "#C59449",
      ],
      nickname: "",
    };
  },
  created() {
    // console.log(this.$route.path);
    this.currentPath = this.$route.path;
    if (this.$route.query.subjectId || this.$route.query.subjectsId) {
        this.color =
          "background:linear-gradient(#5A82F7, #6288F5) !important";
      // if (this.$route.query.subjectId) {
      //   this.color =
      //     "background: " +
      //     this.color_s[this.$route.query.subjectId - 1] +
      //     " !important";
      // } else {
      //   this.color =
      //     "background: " +
      //     this.color_s[this.$route.query.subjectsId - 1] +
      //     " !important";
      // }
    }else{
      this.color =
      "background:linear-gradient(#5A82F7, #6288F5) !important";
    }
    // console.log(this.color);
    if (sessionStorage.getItem("user_info")) {
      let user = JSON.parse(sessionStorage.getItem("user_info"));
      this.nickname = user.nickname
    }else{
      this.getUser();
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    getUser() {
      this.$api.basicData
        .infoProfile()
        .then((res) => {
          // console.log(res);
          if (res.code == 0) {
          
            this.nickname =res.data.nickname
            sessionStorage.setItem("user_info", JSON.stringify(res.data));
           
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped lang='less'>
.header_wrap {
  max-width: 800px;
}
.home_header,
.other_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  line-height: 50px;
  padding: 0 15px;
  color: white;
}
.home_header {
  background: white;
  // color:rgb(148, 96, 41)
}
.home_left {
  font-weight: 600;
  font-size: 18px;
}
.other_left,
.other_right {
  // font-weight: 600;
  letter-spacing: 1px;
}
</style>